import { toPng } from '@intuiface/html-to-image'

const captureAppleFrontPreview = async () => {
  const node = document.getElementById('appleFront')

  if (!node) throw new Error('Apple front preview node not found')

  node.classList.add("preview")

  try {
    return await toPng(node, { cacheBust: true })
  }
  finally {
    node.classList.remove("preview")
  }
}

export default captureAppleFrontPreview
